export const getFullAddress = (address: any): string => {
    const addressParts = [
        address?.addressLineOne || '',
        address?.city || '',
        address?.state || '',
        address?.country || '',
        address?.pincode || ''
    ].filter(Boolean);
    return addressParts.join(", ")
}